const greaterThanZero = (number) => number > 0 ? number : 0;

export default greaterThanZero